module.exports = __webpack_public_path__ + "img/control1.6d931913.svg";